import PageHeader from "../../components/UI/PageHeader";
import ChannelPreferance from "../../components/section/ChannelPreferance";

const AlertSettings = () => {
  return (
    <>
      <PageHeader title="Alert Settings" />
      <div className="w-full flex justify-center bg-gray-100">
        <div className="w-full max-w-[600px] overflow-y-auto h-[calc(100vh-61px)] sm:h-[calc(100vh-73px)] md:h-[calc(100vh-69px)] lg:h-[calc(100vh-79px)] px-4 py-6">
          <p className="px-1 mb-2 text-xs font-semibold tracking-wider uppercase text-gray-400">
            Notification Channels
          </p>
          <ChannelPreferance />
          <p className="px-1 mt-3 text-xs text-gray-400">
            Choose how you'd like to receive tender alerts.
          </p>
        </div>
      </div>
    </>
  );
};

export default AlertSettings;
